module.exports = __webpack_public_path__ + "img/faq-img.cb8032e8.png";